import React, { useEffect } from 'react'
import PaymentCard from './PaymentCard/PaymentCard';
import Card from '../../Elements/Card';
import { PoweredByCoti } from '../../Footer/Footer';
import PaymentQR from './PaymentQR';
import { DotLoader } from 'react-spinners';
import PaymentIdCard from './PaymentIdCard';
import {
  openSocketConnection,
} from '../../../store/actions';
import { config } from '../../../config';
import './PaymentPage.scss';
import PaymentHistory from './PaymentHistory';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import PaymentSent from './PaymentSent';
import {BigDecimal} from 'bigdecimal';
import { track } from '../../../shared/analytics';

const { statuses } = config;

export const PaymentPage = () => {
  const dispatch = useDispatch();
  const params = useParams();

  const {
    paymentRequest: { 
      uuid: paymentId,
      status,
      amount: requestedAmount,
      receiverName,
      confirmedAmount,
      pendingAmount,
      createTime,
      addressHash,
      expirationTime 
    },
    transactions
  } = useSelector(({app}) => app);

  const merchantData = config.merchants[receiverName] ?? config.merchants['save-the-children'];
  
  const confirmedAmountBD = new BigDecimal(confirmedAmount?.toString() ?? '0');
  const pendingAmountBD = new BigDecimal(pendingAmount?.toString() ?? '0');
  const requestedAmountBD = new BigDecimal(requestedAmount?.toString() ?? '0');

  const sentAmountBD = pendingAmountBD.add(confirmedAmountBD);
  const amountLeftToPay = requestedAmountBD.add(sentAmountBD.negate()).toString();
  const sentAmount = sentAmountBD.toString();

  useEffect(() => {
    if(params?.paymentId) {
      dispatch(openSocketConnection(params?.paymentId));
    }
    //eslint-disable-next-line
  }, [params?.paymentId]);

  const renderPaymentView = () => {
    switch(status) {
      case statuses.pending:
        return <PaymentQR addressHash={addressHash} requestedAmount={requestedAmount} expirationTime={expirationTime} />
      case statuses.payment_sent: 
        return <PaymentSent createTime={createTime} sentAmount={sentAmount} />
      case statuses[status]:
        return <PaymentIdCard status={status} paymentId={paymentId} confirmedAmount={confirmedAmountBD.toString()}/>
      default: 
        return null;
    }
  }

  if(!config.statuses[status]) {
    return <div className="no-payment-data-container">
      {!status ? <div className="loader-position"><DotLoader sizeUnit={"px"} size={90} color={'#00062a'} loading={true} /></div> : 
      <div className="payment-page-component__container--title-oops"> 
        <h2>Oops!</h2>
        <p>Something went wrong.</p>
      </div>}
    </div>
  }

  return (
    <div className={`payment-page-component ${status ?? ''}`}>
      <div className="payment-page-component__curved-bg" style={{display: status === null ? 'flex' : 'block'}}>
        <div className="payment-page-component__container">
            <PaymentCard merchantData={merchantData}>
              {status === statuses.pending && <p className="payment-page-component__container--title">To complete your payment, please send {config.currencies.ADA.symbol} to the address below</p>}
              <div className="payment-page-component__container--card-container">
                <Card className={`payment-page-component__container--card ${status}`}>
                  {renderPaymentView()}
                  {(status !== statuses.expired) && <PaymentHistory 
                    status={status}
                    amountLeftToPay={amountLeftToPay} 
                    sentAmount={sentAmount} 
                    transactions={transactions} 
                  />}
                </Card>
              </div>

              {status !== statuses.paid && <div className="payment-page-component__container--card-merchant-btn">
                <a className="button" rel="noopener noreferrer" onClick={() => track('Donate - Save the children ', 'Back to merchant')} href={merchantData['returnUrl'] ?? "#"}>Back to merchant</a>
              </div>}

              <PoweredByCoti className="payment-page-component__container--card-powered-by" />
            </PaymentCard>
          </div>
      </div>
    </div>
  )
}

export default PaymentPage;

